<template>
  <div>
    <table class="table">
      <thead>
        <slot name="columns">
          <tr>
            <th
              v-for="column in columns"
              :key="column"
              :class="{ viewMobile: column != 'Placa' }"
            >
              {{ column }}
            </th>
            <th>Opciones</th>
          </tr>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <td
              v-for="column in columns"
              :key="column"
              v-if="hasValue(item, column)"
              :class="{ viewMobile: column != 'Placa' }"
            >
              {{ itemValue(item, column) }}
            </td>
            <td>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openReportPopup(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-paper-2"></i>
              </button>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openEditPopup(item)"
              >
                <i
                  style="color: #004aad"
                  class="nc-icon nc-settings-gear-64"
                ></i>
              </button>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openMapPopup(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-delivery-fast"></i>
              </button>
              <button
                v-if="id_company != 2"
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openGeofencePopup(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-map-big"></i>
              </button>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openSmsPopup(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-button-power"></i>
              </button>
            </td>
          </slot>
        </tr>
      </tbody>
    </table>
    <vs-popup
      classContent="popup-example"
      title="Comandos"
      :active.sync="popupSms"
    >
      <div style="flex-direction: column" class="row">
        <div class="col-xl-4 col-md-4">
          <h4 style="margin: 0">{{ formSms.placa }}</h4>
        </div>
        <div style="display: flex" class="buttonsCommandMobile">
          <div v-if="id_company != 2" style="padding: 1rem">
            <vs-button
              color="#004aad"
              type="filled"
              icon="highlight_off"
              @click="sendSms('off')"
              >Apagar</vs-button
            >
          </div>
          <div v-if="id_company != 2" style="padding: 1rem">
            <vs-button
              color="#004aad"
              type="filled"
              icon="check_box"
              @click="sendSms('on')"
              >Encender</vs-button
            >
          </div>
          <div style="padding: 1rem">
            <vs-button
              color="#004aad"
              type="filled"
              icon="restart_alt"
              @click="sendSms('reset')"
              >Reiniciar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Geocercas"
      :active.sync="popupGeofence"
    >
      <div
        style="
          justify-content: space-between;
          padding-left: 3%;
          align-items: center;
        "
        class="row"
      >
        <div>
          <h4 style="margin: 0">{{ form.placa }}</h4>
        </div>
        <div style="align-self: flex-end" class="col-xl-4 col-md-4">
          <button
            style="border: none; background-color: #004aad"
            class="btn btn-info btn-fill float-right"
            @click="activeCreateGeofence = true"
          >
            Crear Geocerca
          </button>
        </div>
      </div>
      <p v-if="geofences.length == 0">
        No hay Geocercas registrados para este Vehículo
      </p>
      <div v-else>
        <table class="table">
          <thead>
            <slot name="columns">
              <tr>
                <th>Nombre</th>
                <th>Estado</th>
                <th>Opciones</th>
              </tr>
            </slot>
          </thead>
          <tbody>
            <tr v-for="(item, index) in geofences" :key="index">
              <slot :row="item">
                <td>{{ item.name }}</td>
                <td v-if="item.status">Activo</td>
                <td v-else>Inactivo</td>
                <td>
                  <button
                    type="button"
                    class="navbar-toggler navbar-toggler-right"
                    aria-controls="navigation-index"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    @click="openEditGeofence(item)"
                  >
                    <i
                      style="color: #004aad"
                      class="nc-icon nc-settings-gear-64"
                    ></i>
                  </button>
                  <button
                    type="button"
                    class="navbar-toggler navbar-toggler-right"
                    aria-controls="navigation-index"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    @click="confirmDeleteGeofence(item)"
                  >
                    <i
                      style="color: #004aad"
                      class="nc-icon nc-simple-remove"
                    ></i>
                  </button>
                </td>
              </slot>
            </tr>
          </tbody>
        </table>
      </div>
      <vs-popup
        classContent="popup-example"
        title="Mapa"
        :active.sync="activeEditGeofence"
      >
        <div>
          <div class="row">
            <div style="align-self: flex-end" class="col-xl-12 col-md-12">
              <button
                style="border: none; background-color: #004aad"
                class="btn btn-info btn-fill float-right"
                @click="editGeofence"
              >
                Editar
              </button>
            </div>
            <div class="row col-xl-12 col-md-12">
              <div class="col-xl-6 col-md-6">
                <vs-input
                  label="Nombre"
                  class="inputx"
                  v-model="formEditGeofence.name"
                />
              </div>
              <div
                style="align-self: flex-end; flex-basis: fit-content"
                class="col-xl-4 col-md-4"
              >
                <vs-checkbox
                  style="font-size: medium"
                  v-model="formEditGeofence.status"
                  >Estado</vs-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div style="padding-top: 5%">
          <GmapMap
            ref="map"
            id="map1"
            :center="center"
            :zoom="9"
            :options="options"
            map-type-id="terrain"
            :disableDefaultUI="true"
          >
            <GmapPolygon
              :path="formEditGeofence.polygon"
              :options="polygonOptions"
              :editable="true"
              :draggable="true"
              :shapes="shapes"
              @path_changed="updateEdited($event)"
            ></GmapPolygon>
          </GmapMap>
        </div>
      </vs-popup>
      <vs-popup
        classContent="popup-example"
        title="Mapa"
        :active.sync="activeCreateGeofence"
      >
        <div style="display: flex; justify-content: space-between" class="row">
          <div style="align-self: flex-end" class="col-xl-12 col-md-12">
            <button
              style="border: none; background-color: #004aad"
              class="btn btn-info btn-fill float-right"
              @click="createGeofence"
            >
              Crear
            </button>
          </div>
          <div class="row col-xl-12 col-md-12">
            <div class="col-xl-6 col-md-6">
              <vs-input
                label="Nombre"
                class="inputx"
                v-model="formGeofence.name"
              />
            </div>
            <div
              style="align-self: flex-end; flex-basis: fit-content"
              class="col-xl-4 col-md-4"
            >
              <vs-checkbox
                style="font-size: medium"
                v-model="formGeofence.status"
                >Estado</vs-checkbox
              >
            </div>
          </div>
        </div>
        <div style="padding-top: 5%">
          <GmapMap
            ref="map"
            id="map1"
            :center="center"
            :zoom="9"
            :options="options"
            map-type-id="terrain"
            :disableDefaultUI="true"
          >
            <GmapDrawingManager
              :polygonOptions="polygonOptions"
              :options="drawingOptions"
              :shapes.sync="shapes"
            >
            </GmapDrawingManager>
          </GmapMap>
        </div>
      </vs-popup>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Reporte de Alertas"
      :active.sync="popupReport"
    >
      <div class="row">
        <div class="col-xl-4 col-md-3">
          <vs-input
            label="Cuenta"
            disabled
            class="inputx"
            v-model="formReport.cuenta"
          />
        </div>
        <div class="col-xl-4 col-md-3">
          <vs-input
            type="datetime-local"
            format-value="MM-DD-YYYY HH:mm"
            label="Inicio"
            class="inputx"
            v-model="formReport.inicio"
          />
        </div>
        <div class="col-xl-4 col-md-3">
          <vs-input
            type="datetime-local"
            label="Fin"
            class="inputx"
            v-model="formReport.fin"
          />
        </div>
        <div class="col-xl-4 col-md-3">
          <vs-select class="inputx" label="Evento" v-model="formReport.event">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options1"
            />
          </vs-select>
        </div>
        <div
          style="
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
          "
          class="buttonMobile col-xl-4 col-md-3"
        >
          <button
            style="border: none; background-color: #004aad"
            class="buttonMobile btn btn-info btn-fill float-right"
            @click="exportReportEventAlert()"
          >
            Exportar
          </button>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Editar Vehículo"
      :active.sync="popupEdit"
    >
      <div class="row">
        <div class="col-xl-4 col-md-4">
          <vs-input
            label="Cuenta"
            disabled
            class="inputx"
            v-model="form.cuenta"
          />
        </div>
        <div class="col-xl-4 col-md-4">
          <vs-input
            label="Placa"
            class="inputx"
            placeholder="Placa"
            v-model="form.placa"
          />
        </div>
        <div class="col-xl-4 col-md-4">
          <vs-input
            label="Marca"
            class="inputx"
            placeholder="Marca"
            v-model="form.marca"
          />
        </div>
        <div class="col-xl-4 col-md-4">
          <vs-input
            label="Modelo"
            class="inputx"
            placeholder="Modelo"
            v-model="form.modelo"
          />
        </div>
        <div class="col-xl-4 col-md-4">
          <vs-input
            label="Color"
            class="inputx"
            placeholder="Color"
            v-model="form.color"
          />
        </div>
        <div class="col-xl-4 col-md-4" style="margin-top: 5px">
          <vs-select class="inputx" label="Icono" v-model="form.svg">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.name"
              v-for="(item, index) in availableIconTypes"
            />
          </vs-select>
        </div>
        <div class="col-xl-4 col-md-4" style="display: flex" v-if="form.svg">
          <vs-input
            class="color-svg"
            type="color"
            label="Color icono"
            v-model="form.svg_color"
          />
          <div class="col-4 pb-3" style="display: flex; align-items: flex-end">
            <img :src="getIcon(form.svg, form.svg_color)" />
          </div>
        </div>
        <div
          class="col-xl-12 col-md-12 align-content-center mt-4 mb-4"
          style="justify-items: self-start"
        >
          <vs-checkbox label="auto apagado" v-model="form.auto_off"
            >Auto Apagado
          </vs-checkbox>
        </div>
        <div
          style="
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
          "
          class="buttonMobile col-xl-4 col-md-4"
        >
          <button
            style="border: none; background-color: #004aad"
            class="btn btn-info btn-fill float-right"
            @click="editVehicle()"
          >
            Editar
          </button>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      :title="'Reporte de Posición ' + form.cuenta"
      :active.sync="popupMap"
    >
      <div class="row">
        <div class="col-xl-5 col-md-5">
          <vs-input
            type="datetime-local"
            label="Inicio"
            class="inputx"
            v-model="inicio"
          />
        </div>
        <div class="col-xl-5 col-md-5">
          <vs-input
            type="datetime-local"
            label="Fin"
            class="inputx"
            v-model="fin"
          />
        </div>
        <div
          style="
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
          "
          class="buttonMobile col-xl-2 col-md-2"
        >
          <button
            style="border: none; background-color: #004aad"
            class="btn btn-info btn-fill float-right"
            @click="getEventsVehicle()"
          >
            Buscar
          </button>
        </div>
      </div>
      <div v-show="map">
        <div
          style="margin-top: 10px; padding-left: 0"
          class="col-xl-6 col-md-5"
        >
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">kilómetros</p>
              <h4 class="card-title">{{ kilometers }}</h4>
            </div>
          </stats-card>
        </div>
        <gmap-map
          id="map1"
          :center="center"
          :zoom="15"
          :options="options"
          map-type-id="terrain"
          :disableDefaultUI="true"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
          </gmap-info-window>
          <gmap-marker
            :key="id"
            v-for="(tr, id) in events"
            :position="tr.center"
            :icon="tr.icon"
            :clickable="true"
            @click="toggleInfoWindow(tr, id)"
          >
          </gmap-marker>
          <gmap-polyline
            :options="{
              strokeOpacity: 1,
              strokeColor: '#808080',
              icons: [
                {
                  icon: { path: 'M 0,0 2,2 M 0,0 -2,2' },
                  offset: '0%',
                  repeat: '50px',
                },
              ],
            }"
            :path="flightPlanCoordinates"
          />
        </gmap-map>
      </div>
    </vs-popup>
    <vs-prompt
      @accept="deleteGeofence"
      :active.sync="activePrompt"
      acceptText="Aceptar"
      cancelText="Cancelar"
      title="Eliminar"
    >
      <div class="con-example-prompt">
        ¿Esta seguro que desea eliminar la Geocerca?
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import Vue from "vue";
import vuesax from "vuesax";
import StatsCard from "src/components/Cards/StatsCard.vue";
import "vuesax/dist/vuesax.css";
import "material-icons/iconfont/material-icons.css";
import GmapVue from "gmap-vue";
import getSecret from "../helpers/get-secret";
import { getIconUrl, getAvailableIconTypes } from "../helpers/iconHelper.js";
import { API_KEY } from "../pages/Maps/API_KEY";
const serverUrl = getSecret("SERVER_URL");

Vue.use(GmapVue, {
  load: {
    key: API_KEY,
  },
});
Vue.use(vuesax);

export default {
  name: "l-table",
  props: {
    columns: Array,
    data: Array,
  },
  components: {
    StatsCard,
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem("jwt_licencia")).id_company,
      popupReport: false,
      popupSms: false,
      popupEdit: false,
      popupMap: false,
      activePrompt: false,
      activeEditGeofence: false,
      popupGeofence: false,
      events: null,
      map: false,
      inicio: "",
      fin: "",
      kilometers: 0,
      flightPlanCoordinates: [],
      activeCreateGeofence: false,
      polygons: [],
      geofences: [],
      geofencesEdit: [],
      shapes: [],
      formSms: {
        phone: "",
        msg: "",
        placa: "",
        id_company: JSON.parse(localStorage.getItem("jwt_licencia")).id_company,
        user: JSON.parse(localStorage.getItem("jwt_user")).email,
      },
      drawingOptions: {
        drawingControl: true, // Mostrar controles de dibujo en el mapa
        drawingControlOptions: {
          position: "TOP_CENTER", // Posición de los controles de dibujo
          drawingModes: ["marker", "polygon", "polyline", "circle"], // Modos de dibujo permitidos
        },
      },
      polygonOptions: {
        fillColor: "#FF0000",
        fillOpacity: 0.4,
        strokeWeight: 2,
        strokeColor: "#FF0000",
        draggable: false,
        editable: true,
        clickable: true,
      },
      options1: [
        { text: "Exceso de Velocidad", value: 32 },
        { text: "Desconexión de Batería", value: 18 },
        { text: "Pánico", value: 21 },
        { text: "Todos los Eventos", value: 1 },
      ],
      form: {
        cuenta: "",
        placa: "",
        marca: "",
        modelo: "",
        color: "",
        auto_off: false,
        svg: null,
        svg_color: null,
      },
      formReport: {
        cuenta: "",
        event: "",
        inicio: "",
        fin: "",
      },
      formGeofence: {
        name: "",
        status: true,
        polygon: [],
        id_geofence: "",
        id_company: "",
        cuenta: "",
      },
      formEditGeofence: {
        name: "",
        status: true,
        polygon: [{ lat: 1, lng: 1 }],
        id_geofence: "",
        id_company: "",
        cuenta: "",
      },
      infoWindowPos: null,
      availableIconTypes: [],
      infoWinOpen: false,
      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      center: {
        lat: 0,
        lng: 0,
      },
      options: {
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }],
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }],
          },
          { featureType: "poi.park", stylers: [{ visibility: "off" }] },
          {
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "off" }],
          },
          { featureType: "poi.medical", stylers: [{ visibility: "off" }] },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }],
          },
        ],
      },
    };
  },
  created() {
    this.availableIconTypes = getAvailableIconTypes();
  },
  watch: {
    activeCreateGeofence: function (newVal) {
      if (!newVal) {
        this.formGeofence = {
          name: "",
          status: true,
          polygon: [],
          id_geofence: "",
          id_company: "",
          cuenta: "",
        };
      }
    },
    activeEditGeofence: function (newVal) {
      if (!newVal) {
        this.formEditGeofence = {
          name: "",
          status: true,
          polygon: [{ lat: 1, lng: 1 }],
          id_geofence: "",
          id_company: "",
          cuenta: "",
        };
        this.geofencesEdit = [];
      }
    },
  },
  methods: {
    getIcon(type, color) {
      return getIconUrl(type, color);
    },
    editGeofence() {
      if (this.geofencesEdit.length > 0) {
        const path = this.geofencesEdit.getArray();
        this.coords = [];
        path.forEach((coord) => {
          const lat = coord.lat();
          const lng = coord.lng();
          const point = { lat: lat, lng: lng };
          this.coords.push(point);
        });
        this.polygons.push({
          path: this.coords,
        });
        this.formEditGeofence.polygon = this.coords;
      }
      console.log(this.formEditGeofence.polygon);
      this.axios
        .post(serverUrl + "/api/editGeofence", this.formEditGeofence)
        .then((res) => {
          if (res.data.status == 200) {
            this.activeEditGeofence = false;
            this.popupGeofence = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Geocerca Editada.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al editar la geocercas.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    updateEdited($event) {
      this.geofencesEdit = $event;
    },
    openEditGeofence(item) {
      this.formEditGeofence.name = item.name;
      this.formEditGeofence.status = item.status;
      this.formEditGeofence.polygon = item.polygon;
      this.formEditGeofence.id_geofence = item.id_geofence;
      this.shapes = item.polygon;
      this.activeEditGeofence = true;
    },
    confirmDeleteGeofence(item) {
      this.activePrompt = true;
      this.id_item = item.id_geofence;
      this.account = item;
    },
    deleteGeofence() {
      this.axios
        .get(serverUrl + "/api/deleteGeofence/" + this.id_item)
        .then((res) => {
          if (res.data.status == 200) {
            this.popupGeofence = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Geocerca Eliminado con Éxito.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Geocerca.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Geocerca.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    createGeofence() {
      this.formGeofence.id_company = this.id_company;
      const path = this.shapes[0].overlay.getPath().getArray();
      this.coords = [];
      path.forEach((coord) => {
        const lat = coord.lat();
        const lng = coord.lng();
        const point = { lat: lat, lng: lng };
        this.coords.push(point);
      });
      this.polygons.push({
        path: this.coords,
      });
      this.formGeofence.polygon = this.coords;
      this.axios
        .post(serverUrl + "/api/createGeofence", this.formGeofence)
        .then((res) => {
          if (res.data.status == 200) {
            this.activeCreateGeofence = false;
            this.popupGeofence = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Geocerca Creada.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al crear la geocercas.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    sendSms(msg) {
      this.formSms.msg = msg;
      this.axios
        .post(serverUrl + "/api/sendSms", this.formSms)
        .then((res) => {
          if (res.data.status == 200) {
            this.popupSms = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Comando Enviado.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Al enviar el comando.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Al enviar el comando.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    openSmsPopup(item) {
      this.formSms.phone = item.sim_card;
      this.formSms.placa = item.placa;
      this.popupSms = true;
    },
    openReportPopup(item) {
      this.popupReport = true;
      this.formReport.cuenta = item.cuenta;
      this.formReport.inicio = "";
      this.formReport.fin = "";
      this.formReport.event = null;
    },
    openEditPopup(item) {
      this.popupEdit = true;
      this.form.cuenta = item.cuenta;
      this.form.placa = item.placa;
      this.form.marca = item.marca;
      this.form.modelo = item.modelo;
      this.form.color = item.color;
      this.form.svg = item.svg;
      this.form.svg_color = item.svg_color;
      this.form.auto_off = item.auto_off;
    },
    openMapPopup(item) {
      this.popupMap = true;
      this.form.cuenta = item.cuenta;
      this.events = null;
      this.map = false;
      this.inicio = "";
      this.fin = "";
    },
    openGeofencePopup(item) {
      this.axios
        .get(serverUrl + "/api/getGeofenceByVehicle/" + item.cuenta)
        .then((res) => {
          if (res.data.status == 200) {
            this.form.placa = item.placa;
            this.formGeofence.cuenta = item.cuenta;
            this.center = {
              lat: parseFloat(item.last_latitude),
              lng: parseFloat(item.last_longitude) * -1,
            };
            this.popupGeofence = true;
            this.geofences = res.data.geofences;
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió al obtener la lista de geocercas.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al obtener la lista de geocercas.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    getReportEventAlert() {
      this.axios
        .get(
          serverUrl +
            "/api/getReportEventAlert/" +
            this.formReport.cuenta +
            "/" +
            this.formReport.inicio +
            "/" +
            this.formReport.fin +
            "/" +
            this.formReport.event
        )
        .then((res) => {
          if (res.data.status == 200) {
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.popupReport = false;
        })
        .catch((err) => {
          this.popupReport = false;
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    exportReportEventAlert() {
      //this.url4 = 'http://107.22.145.98/api/export-report-event-alert/'+this.formReport.cuenta+'/'+this.formReport.inicio+'/'+this.this.formReport.fin+'/'+this.formReport.event;
      let url2 = serverUrl;
      let url3 = `${url2}/api/export-report-event-alert/${this.formReport.cuenta}/${this.formReport.inicio}/${this.formReport.fin}/${this.formReport.event}`;
      window.open(url3, "_blank");
    },
    getEventsVehicle() {
      this.flightPlanCoordinates = [];
      this.axios
        .get(
          serverUrl +
            "/api/getEventsVehicle/" +
            this.form.cuenta +
            "/" +
            this.inicio +
            "/" +
            this.fin
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.events = res.data.events;
            this.center = {
              lat: parseFloat(this.events[0].latitude),
              lng: parseFloat(this.events[0].longitude) * -1,
            };

            this.events.forEach((event) => {
              event.center = {
                lat: parseFloat(event.latitude),
                lng: parseFloat(event.longitude) * -1,
              };
              this.flightPlanCoordinates.push(event.center);
              if (event.event == 10) event.evento = "Reporte Encendido";
              if (event.event == 11) event.evento = "Reporte Apagado";
              if (event.event == 21) event.evento = "Pánico";
              if (event.event == 18) event.evento = "Desconexión de Batería";
              if (event.event == 19) event.evento = "Conexión de Batería";
              if (event.event == 91) event.evento = "Vehículo Apagado";
              if (event.event == 90) event.evento = "Vehículo Encendido";
              if (event.event == 92) event.evento = "GPS apagado";
              if (event.event == 93) event.evento = "GPS offline";
              if (event.event == 94) event.evento = "GPS online";
              if (event.event == 95) event.evento = "Apagado por comando";
              if (event.event == 96) event.evento = "Encendido por comando";
              if (event.event == 97) event.evento = "Error de comunicación";
              if (event.event == 98) event.evento = "Geocerca de inclusion";
              if (event.event == 99) event.evento = "Geocerca de exclusion";
              if (event.event == 1) event.evento = "Test";
              if (event.event == 32) {
                event.evento = "Exceso de Velocidad";
                event.icon = {
                  url: "https://gps.isolutions.website/img/markerAlerta.png",
                };
              }
              event.infoText =
                "<strong>Evento:</strong>" +
                event.evento +
                "<br><strong>Fecha:</strong>" +
                event.date_event +
                "<br><strong>Velocidad:</strong>" +
                event.speed;
            });
            this.kilometers = 0;
            for (let i = 0; i < this.events.length - 1; i++) {
              const puntoActual = this.events[i];
              const puntoSiguiente = this.events[i + 1];
              const latitudActual = puntoActual.latitude;
              const longitudActual = parseFloat(puntoActual.longitude) * -1;
              const latitudSiguiente = puntoSiguiente.latitude;
              const longitudSiguiente =
                parseFloat(puntoSiguiente.longitude) * -1;
              const distancia = this.calcularDistancia(
                latitudActual,
                longitudActual,
                latitudSiguiente,
                longitudSiguiente
              );
              this.kilometers += distancia;
            }
            this.kilometers = this.kilometers.toFixed(2);
            this.map = true;
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte de ubicación.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.popupEdit = false;
        })
        .catch((err) => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte de ubicación.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          console.log("getEventsVehicle:" + err);
        });
    },
    calcularDistancia(lat1, lon1, lat2, lon2) {
      const radioTierra = 6371; // Radio de la Tierra en kilómetros
      const dLat = this.toRadians(lat2 - lat1);
      const dLon = this.toRadians(lon2 - lon1);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRadians(lat1)) *
          Math.cos(this.toRadians(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const distancia = radioTierra * c;
      return distancia;
    },
    toRadians(grados) {
      return grados * (Math.PI / 180);
    },
    editVehicle() {
      this.axios
        .post(serverUrl + "/api/editVehicle", this.form)
        .then((res) => {
          if (res.data.status == 200) {
            this.$root.$emit("getList");
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Vehículo Actualizado.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Vehículo.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.popupEdit = false;
        })
        .catch((err) => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Vehículo.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          this.popupEdit = false;
        });
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
    toggleInfoWindow: function (vehicle, cuenta) {
      this.infoWindowPos = vehicle.center;
      this.infoOptions.content = vehicle.infoText;
      if (this.currentMidx == cuenta) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = cuenta;
      }
    },
  },
};
</script>
<style>
.color-svg {
  input {
    height: 2rem !important;
  }
}

input {
  height: auto !important;
}

.vs-input {
  float: left;
  width: 50%;
  margin-top: 5px;
}

.vs-select {
  float: left;
  width: 50%;
  margin-top: 5px;
}

.con-select {
  width: auto !important;
  clear: both;
}

#map1 {
  min-height: 500px;
  width: 100% !important;
  height: auto;
}

.vs-button {
  height: auto !important;
}

@media (max-width: 767px) {
  .viewMobile {
    display: none;
  }

  .buttonMobile {
    padding-top: 3%;
  }

  .buttonsCommandMobile {
    flex-direction: column;
  }
}

.card {
  margin-bottom: 10px !important;
}
</style>
